var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreekCoffee(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 288 288",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-1,.cls-3{stroke:#765638;stroke-linejoin:round;stroke-width:3px;}.cls-2{fill:#29abe2;}.cls-3,.cls-4{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M108.8,114.67q.67,4.35,1.43,8.81c-2.57-1.51-5.72-2.65-9-2.06-2.56.46-6.16,2.21-8.73,7.93a18.08,18.08,0,0,0,1,16.53c4.51,8.1,15,14.78,24.17,15.59q1.46,6.39,3,12.53h47.46c2.07-8.44,4.07-17.23,5.94-26.37,2.33-11.39,4.29-22.4,5.93-33Zm-9.09,27c-1.71-3.07-1.93-5.92-.67-8.7,1.45-3.22,2.91-3.49,3.39-3.58a3.39,3.39,0,0,1,.64-.06c2.55,0,5.67,2.46,7.27,4l4.38,19.46C108.74,151.06,102.46,146.59,99.71,141.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M139.88,129.08h9.47V125h-5.08a1,1,0,0,1-1-1v-6.1a1,1,0,0,1,1-1h12.19a1,1,0,0,1,1,1v11.17h10.16V125h-5.08a1,1,0,0,1-1-1v-6.1a1,1,0,0,1,1-1h12.19a1,1,0,0,1,1,1v11.17l1.71.49-.15,1.9-2.57-.35a1,1,0,0,1-1-1V118.93H163.57V123h5.08a1,1,0,0,1,1,1v6.09a1,1,0,0,1-1,1H156.46a1,1,0,0,1-1-1V118.93H145.29V123h5.07a1,1,0,0,1,1,1v6.09a1,1,0,0,1-1,1h-10.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M104.23,129.08h9.47V125l-3.37.08c-.56,0-1.26-1.29-1.26-1.85l-.66-5.49c0-.56-.35-.86.21-.86h12.19a1,1,0,0,1,1,1v11.17H132V125H126.9a1,1,0,0,1-1-1v-6.1a1,1,0,0,1,1-1h12.19a1,1,0,0,1,1,1v11.17h2.06v2h-3.08a1,1,0,0,1-1-1V118.93H127.92V123H133a1,1,0,0,1,1,1v6.09a1,1,0,0,1-1,1H120.81a1,1,0,0,1-1-1V118.93H109.64V123h5.08a1,1,0,0,1,1,1v6.09a1,1,0,0,1-1,1H104.51"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M108.8,114.67q.67,4.35,1.43,8.81c-2.57-1.51-5.72-2.65-9-2.06-2.56.46-6.16,2.21-8.73,7.93a18.08,18.08,0,0,0,1,16.53c4.51,8.1,15,14.78,24.17,15.59q1.46,6.39,3,12.53h47.46c2.07-8.44,4.07-17.23,5.94-26.37,2.33-11.39,4.29-22.4,5.93-33Zm-9.09,27c-1.71-3.07-1.93-5.92-.67-8.7,1.45-3.22,2.91-3.49,3.39-3.58a3.39,3.39,0,0,1,.64-.06c2.55,0,5.67,2.46,7.27,4l4.38,19.46C108.74,151.06,102.46,146.59,99.71,141.65Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    width: 288,
    height: 288
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreekCoffee);
export default __webpack_public_path__ + "static/media/greek-coffee.84697c5d0a0bce2b8c40ac8a655c8217.svg";
export { ForwardRef as ReactComponent };